<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { slide } from "svelte/transition";
  import { campaign_theme, CATEGORY_NAVIGATION, CAMPAIGN_MAIN_NAVIGATION } from "../../filters/store";
  import type { CampaignNavigation } from "../../filters/store";
  export let request_store_key: StoresKey;
  const { nav_menus, reverse_router, site, site_page, i18nOf, T } =
    getStoresContext(request_store_key);
  campaign_theme.set("2");
  $: t = $T;
  $: scrollingPosition = 0;
  $: isOpen = false;
  $: logo = $site && $site.logo;

  $: categories =
    $nav_menus &&
    $nav_menus.find((nav) => nav.name == CATEGORY_NAVIGATION[$campaign_theme as keyof CampaignNavigation])
      ?.navigationMenuItems;
  $: current = $site_page?.friendlyUrlPath;

  $: pages =
    $nav_menus &&
    $nav_menus.find((nav) => nav.name == CAMPAIGN_MAIN_NAVIGATION[$campaign_theme as keyof CampaignNavigation])
      ?.navigationMenuItems;
  $: home_page_nav_item = $reverse_router.routePurpose("home page");
  $: show_all_href =
    pages && pages.length ? $reverse_router.routePage(pages[0].link) : "/";
  let h = 0;
</script>

<svelte:window bind:scrollY={scrollingPosition} />

<header
  class="fixed-top"
  class:shadow={scrollingPosition > 50}
  bind:clientHeight={h}>
  <div class="container-fluid h-100">
    <nav class="h-100 d-none d-lg-flex">
      <a class="mb-3" href={home_page_nav_item}>
        <img src={logo} alt="Mall of tripla logo" class="d-block logo" />
      </a>
      <div>
        {#if pages}
          {#each pages as page}
            <a class="main-navigation-item"
              href={page.link ? $reverse_router.routePage(page.link) : page.url}
              class:active={current == page.link}>{i18nOf(page.name_i18n)}</a>
          {/each}
        {/if}
      </div>
    </nav>
    <div class="mobile-menu d-lg-none">
      <div class="d-flex justify-content-between align-items-center p-3 h-100">
        <a class="d-flex align-items-center" href={home_page_nav_item}>
          <img
            src="/theme/malloftripla2024/images/Tripla_logo_mobile.png"
            alt="Mall of tripla logo mobile"
            class="tripla-logo-mobile logo" />
        </a>
        <div
          class:menu-icon-close={isOpen}
          class:menu-icon-burger={!isOpen}
          on:click={() => (isOpen = !isOpen)}
          on:keydown={() => (isOpen = !isOpen)}>
          {#if isOpen}
            <i class="fas fa-times" />
            <div class="close-text fw-bold">{t`close`}</div>
          {:else}
            <i class="fas fa-bars" />
          {/if}
        </div>
      </div>
    </div>
    {#if isOpen}
      <div transition:slide class="d-lg-none" style="margin: 0 -12px;">
        <div class="collapse-mobile-menu">
          {#if pages}
            {#each pages as page}
              <a
                href={page.link
                  ? $reverse_router.routePage(page.link)
                  : page.url}
                class:active={current == page.link}>{i18nOf(page.name_i18n)}</a>
            {/each}
          {/if}
        </div>
      </div>
    {/if}
  </div>
  <div class="category-pages">
    <div class="container-fluid container-fluid-max-xl">
      <div class="row d-none d-lg-flex">
        <div class="col-12 d-flex categories">
          {#if categories && categories.length}
            <a class="category" href={show_all_href}> {t`all`} </a>
            {#each categories as page}
              <a
                class="category"
                class:category-active={current == page.link}
                href={page.link
                  ? $reverse_router.routePage(page.link)
                  : page.url}>{i18nOf(page.name_i18n)}</a>
            {/each}
          {/if}
        </div>
      </div>
    </div>
  </div>
</header>

<div class="gap-element" style="height: {h - 1}px" />

<style lang="scss">
  .main-navigation-item{
    text-transform: uppercase;
    font-size: 16px;
  }
  .category-active {
    background-color: var(--brandColor2) !important;
    color: #fff !important;
  }
  .category {
    padding: 4px 0;
    margin-right: 5px;
    background-color: #fff;
    color: var(--brandColor1);
    width: inherit;
    text-align: center;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
  .category:hover{
    background-color: var(--brandColor2);
    color: #fff;
  }
  .category:last-child{
    margin-right: 0;
  }
  .category-pages {
    background-color: var(--brandColor1);
    .categories {
      justify-content: space-between;
    }
  }
  .active {
    text-decoration: underline;
  }

  .mobile-menu {
    margin: 0 -12px;
    height: 100%;
    color: #fff;
  }
  .collapse-mobile-menu {
    max-height: calc(100vh - 195px);
    overflow: auto;
    z-index: 1;
    background-color: var(--brandColor1);
    color: #ffffff;
    padding: 1rem;
    a {
      display: block;
      padding: 1rem 0;
      color: #ffffff;
    }
  }

  header {
    background-color: var(--brandColor1);
    height: auto;
    a {
      color: #ffffff;
      margin-right: 2rem;
    }
  }
  .close-text {
    color: #ffffff;
  }

  .menu-icon-close {
    font-size: 35px;
    text-align: center;
  }

  .menu-icon-burger {
    font-size: 40px;
    color: #ffffff;
  }

  .close-text {
    font-size: 14px;
    margin-top: -12px;
  }

  nav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }

  @media screen and (min-width: 992px) {
    nav {
      align-items: center;
      padding: 30px 8px;
      flex-direction: column;
    }
    nav img {
      width: 150px;
    }
  }

  @media screen and (min-width: 1200px) {
    nav img {
      width: 190px;
    }
  }

  @media screen and (min-width: 1440px) {
    nav img {
      width: 230px;
    }
  }

  header {
    .tripla-logo-mobile {
      height: 45px;
    }
  }

  .gap-element {
    height: 100px;
    @media screen and (min-width: 992px) {
      height: auto;
    }
  }
  .logo {
    filter: invert(1);
  }
</style>
